import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useAuth } from "../../contexts/authContext"
import Loading from "../layouts/Loading"
import { isValidAccountId } from "../../utils/utils"

const Redirect = ({ to = "/" }) => {

    const { account_id } = useParams()
    const { account, getAccount, getPermissions } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        const timeout = setTimeout(() => {
            redirectToAccountId()
        }, 2000)

        return () => clearTimeout(timeout)
    }, [account_id, account, to])

    const redirectToAccountId = async () => {
        if (account_id) {
            if (!isValidAccountId(account_id)) {
                navigate("/")
            }
            await getAccount(account_id)
            await getPermissions(account_id)
            setTimeout(() => {
                navigate(`/${account_id}${to}`)
            }, 1000)
        }
    }

    return <Loading fullPage={true} />
}

export default Redirect